
// components/About.jsx
import React, { useContext } from "react";
import { FaStar, FaHandshake } from "react-icons/fa";
import { translations } from "../../../components/translation/translation";
import { LangContext } from "../../../components/translation/langugeContext"; 
const About = () => {
  const { lang } = useContext(LangContext); 
  const t = translations[lang]; 

  return (
    <section
      id="about"
      className="pt-32 mt-24 pb-16 bg-gradient-to-b from-[#121525]/95 to-[#121525] relative"
    >
      <div className="container mx-auto px-4">
        <div className="developer-logos-container-no-hover">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div
              className="about-content aos-init aos-animate"
              data-aos="fade-right"
            >
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                {t.aboutTitle}
              </h2>
              <p className="text-gray-300 text-lg leading-relaxed mb-8">
                {t.aboutDescription}
              </p>

              <div className="grid grid-cols-2 gap-6 mb-8 bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/10">
                <div className="text-center">
                  <div
                    style={{ color: "#F9C835" }}
                    className="text-3xl font-bold mb-1"
                  >
                    500+
                  </div>
                  <div className="text-white text-sm">{t.propertiesCount}</div>
                </div>
                <div className="text-center">
                  <div
                    style={{ color: "#F9C835" }}
                    className="text-3xl font-bold mb-1"
                  >
                    1000+
                  </div>
                  <div className="text-white text-sm">{t.clientsCount}</div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/10">
                  <div
                    style={{ backgroundColor: "#F9C835" }}
                    className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                  >
                    <FaStar className="text-[#121525] text-xl" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {t.excellenceTitle}
                  </h3>
                  <p className="text-gray-300">{t.excellenceText}</p>
                </div>

                <div className="bg-white/10 backdrop-blur-lg rounded-xl p-6 border border-white/10">
                  <div
                    style={{ backgroundColor: "#F9C835" }}
                    className="w-12 h-12 rounded-full flex items-center justify-center mb-4"
                  >
                    <FaHandshake className="text-[#121525] text-xl" />
                  </div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {t.trustTitle}
                  </h3>
                  <p className="text-gray-300">{t.trustText}</p>
                </div>
              </div>
            </div>

            <div
              className="about-images grid grid-cols-2 gap-4 aos-init aos-animate"
              data-aos="fade-left"
            >
              <div class="mission-image relative h-[600px] mt-8 col-span-2">
                <img
                  src="img/about/2.jpg"
                  alt="AboutImage2"
                  className="w-full h-full object-cover rounded-xl shadow-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
